import { Tab, styled } from "@mui/material";

export const SmallTab = styled(Tab)({
  minHeight: "auto",
  padding: 10
});